<template>
  <div class="p-1">
    <h6 class="mb-1">
      Select a Collection
    </h6>
    <p class="text-muted mb-2">
      Choose the collection you want to create shipments for.
    </p>
    <b-dropdown
      class="filter-dropdown w-100"
      variant="outline-none"
      block
      no-caret
      menu-class="w-100 filter-dropdown-menu scroll-bar collection-dropdown-menu"
      toggle-class="filter-dropdown-toggle"
      no-flip
    >
      <template #button-content>
        <div
          class="d-flex justify-content-between"
          :class="{ 'has-value': !!selectedCollection }"
        >
          <span>{{ selectedCollection || 'Select collection...' }}</span>
          <feather-icon icon="ChevronDownIcon" />
        </div>
      </template>
      <b-dropdown-text>
        <b-form-input
          v-model="searchText"
          placeholder="Search collections..."
          class="filter-dropdown-toggle"
          @input="onSearch"
        />
        <div
          v-if="!filteredCollections.length && !isLoading"
          class="py-2 text-center"
        >
          No collections found.
        </div>
        <div
          v-if="isLoading"
          class="py-2 text-center"
        >
          <b-spinner small />
        </div>
      </b-dropdown-text>
      <b-dropdown-item
        v-for="collection in filteredCollections"
        :key="collection._id"
        :active="selectedCollection === collection.name"
        @click="onSelect(collection)"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>{{ collection.name }}</span>
          <b-badge
            pill
            :variant="getStatusVariant(collection.status)"
          >
            {{ getStatusText(collection.status) }}
          </b-badge>
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import {
  BDropdown,
  BDropdownItem,
  BDropdownText,
  BFormInput,
  BSpinner,
  BBadge,
} from 'bootstrap-vue'
import store from '@/store'
import { GET_COLLECTION_LIST } from '@/store/modules/collection.module'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BDropdownText,
    BFormInput,
    BSpinner,
    BBadge,
    FeatherIcon,
  },
  props: {
    selectedCollection: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      collections: [],
      searchText: '',
      isLoading: false,
    }
  },
  computed: {
    filteredCollections() {
      if (!this.searchText) return this.collections
      const q = this.searchText.toLowerCase()
      return this.collections.filter(c => (c.name || '').toLowerCase().includes(q))
    },
  },
  created() {
    this.loadCollections()
  },
  methods: {
    onSearch(text) {
      this.searchText = text
    },
    loadCollections() {
      this.isLoading = true
      store.dispatch(GET_COLLECTION_LIST).then(res => {
        this.collections = res?.data?.data?.collections || []
      }).finally(() => {
        this.isLoading = false
      })
    },
    onSelect(collection) {
      this.$emit('select', { id: collection._id, name: collection.name })
    },
    getStatusVariant(status) {
      if (status === 'live') return 'success'
      if (status === 'expired') return 'secondary'
      return 'info'
    },
    getStatusText(status) {
      if (status === 'live') return 'Live'
      if (status === 'expired') return 'Expired'
      if (status === 'new') return 'New'
      if (status === 'pending') return 'In Review'
      return status
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .collection-dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
}
</style>
